import * as api from '../api/interactions.js';
import q from '../query.js';
export const emailServersEntity = 'email-servers';
const emailServerKey = (id) => `email-server-${id}`;
export const useEmailServer = (id) => q.query(emailServerKey(id), () => (id ? api.getEmailServer(id) : null), [], {
    enabled: id != null,
});
//# sourceMappingURL=index.js.map